import Vue from 'vue'
import Router from 'vue-router'

const Index = () => import('../components/pages/index')
const Pollution = () => import('../components/pages/pollution')
const ReportPollution = () => import('../components/pages/report-pollution')
const Thanks = () => import('../components/pages/thanks')
const Issue = () => import('../components/pages/issue')
const Fish = () => import('../components/pages/fish')
const ReportFish = () => import('../components/pages/report-fish')
const Guide = () => import('../components/pages/guide')

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    {
      path: '/index.html',
      redirect: {
        name: 'index'
      }
    },
    {
      path: '/pollution',
      name: 'pollution',
      component: Pollution
    },
    {
      path: '/pollution/:category',
      name: 'pollutionCategory',
      component: Pollution
    },
    {
      path: '/thanks/:type',
      name: 'thanks',
      component: Thanks
    },
    {
      path: '/issues/:id',
      name: 'issue',
      component: Issue
    },

    {
      path: '/fish',
      name: 'fish',
      component: Fish
    },
    {
      path: '/report/fish',
      name: 'reportFish',
      component: ReportFish
    },
    {
      path: '/report/pollution',
      name: 'reportPollution',
      component: ReportPollution
    },
    {
      path: '/guide',
      name: 'guide',
      component: Guide
    }
  ]

})
